import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";
import type {GetResponse} from "@/src/modules/core/types";

import type {DailyActivityReport, DailyActivityReportCode, DailyActivityReportType} from "../types";

const PATH = "dailyactivityreport";
const DARS_META = {feature: "dars"} as const;

class DarsApi extends ResourceApi<DailyActivityReport> {
  constructor() {
    super(PATH);
  }

  create(data: Record<string, unknown>): Promise<AxiosResponse<GetResponse<DailyActivityReport>>> {
    return super.create(data, {meta: {...DARS_META, operation: "dar_save"}});
  }

  update(
    id: number,
    data: Record<string, unknown>,
  ): Promise<AxiosResponse<GetResponse<DailyActivityReport>>> {
    return super.update(id, data, {meta: {...DARS_META, operation: "dar_submit"}});
  }

  getDarCodes(): Promise<
    AxiosResponse<{daily_activity_report_codes: DailyActivityReportCode[]}>
  > {
    return this.get("dailyactivityreportcode");
  }

  getDarTypes(): Promise<
    AxiosResponse<{
      daily_activity_report_types: DailyActivityReportType[];
    }>
  > {
    return this.get("dailyactivityreporttype");
  }
}

export const darsApi = new DarsApi();
